/* Vanillove upsell: Kup w zestawie, większe opakowanie, dobierz do darmowej dostawy. */
(() => {
  if (window.__vlUpsell) return;
  window.__vlUpsell = true;

  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const money = (cents) => {
    try {
      if (window.theme && window.theme.formatMoney && window.theme.moneyFormat) return window.theme.formatMoney(cents, window.theme.moneyFormat);
    } catch (e) {}
    return (cents / 100).toLocaleString('pl-PL', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' zł';
  };
  const qtyOf = (option) => {
    const m = String(option || '').match(/(\d+(?:[.,]\d+)?)/);
    return m ? parseFloat(m[1].replace(',', '.')) : 0;
  };
  // jednostka z nazwy wariantu: „20 lasek”, „100 GRAM”, „50ml”
  const unitOf = (option) => {
    const o = String(option || '').toLowerCase();
    if (/las(ek|ki|ka)/.test(o)) return { kind: 'laski', short: 'lasek', per: 'laskę' };
    if (/ml\b|ml$/.test(o)) return { kind: 'ml', short: 'ml', per: 'ml' };
    if (/gram|\dg\b|\sg\b/.test(o)) return { kind: 'g', short: 'g', per: 'gram' };
    return { kind: '' };
  };
  const lasekForm = (n) => (n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 12 || n % 100 > 14) ? 'laski' : n === 1 ? 'laska' : 'lasek');

  const post = async (path, body) => {
    const r = await fetch(root + path, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
    const j = await r.json().catch(() => ({}));
    if (!r.ok || j.status >= 400) throw new Error(j.description || j.message || 'Nie udało się zaktualizować koszyka');
    return j;
  };

  // Źródło sprzedaży w atrybucie koszyka _vl_upsell (trafia do zamówienia jako note_attributes).
  const track = async (tag) => {
    try {
      const cart = await (await fetch(root + 'cart.js')).json();
      const cur = ((cart.attributes || {})._vl_upsell || '').split(',').filter(Boolean);
      if (cur.includes(tag)) return;
      cur.push(tag);
      await post('cart/update.js', { attributes: { _vl_upsell: cur.join(',') } });
    } catch (e) {}
  };

  const refreshCart = (open) => {
    document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
    const drawer = document.querySelector('cart-items[data-cart-drawer]');
    if (open && drawer && typeof drawer.openCartDrawer === 'function') drawer.openCartDrawer();
    else if (!drawer && /\/cart\/?$/.test(location.pathname)) location.reload();
  };

  const productScope = (el) => el.closest('product-info, [data-section-type="product"], .product-single, section') || document;
  const currentVariantId = (scope) => {
    const input = scope.querySelector('form[action*="/cart/add"] input[name="id"]') || document.querySelector('form[action*="/cart/add"] input[name="id"]');
    return input ? Number(input.value) : 0;
  };

  /* ---------- Większe opakowanie na stronie produktu ---------- */
  const initUpgrade = (el) => {
    if (el.dataset.vlReady) return;
    el.dataset.vlReady = '1';
    let variants;
    try { variants = JSON.parse(el.querySelector('[data-vl-variants]').textContent); } catch (e) { return; }
    // motyw podmienia DOM przy zmianie wariantu, więc selektor wariantów szukamy za każdym razem od nowa
    const getPicker = () => productScope(el).querySelector('variant-selects') || document.querySelector('variant-selects');
    const picker = getPicker();
    if (picker) picker.insertAdjacentElement('afterend', el);
    const msg = el.querySelector('[data-vl-up-msg]');
    const badge = el.querySelector('[data-vl-up-badge]');
    const btn = el.querySelector('[data-vl-up-btn]');
    let best = null;

    // cena za jednostkę (laskę, gram, ml) liczona z ceny wariantu: pod każdym wariantem i w podpowiedzi
    const unitPrice = (v) => { const q = qtyOf(v.option1); return q ? Math.round(v.price / q) : 0; };
    const unitShort = { laski: 'szt.', g: 'g', ml: 'ml' };
    const packLabel = (v) => { const u = unitOf(v.option1), q = qtyOf(v.option1); return u.kind === 'laski' ? `${q} ${lasekForm(q)}` : u.kind ? `${q} ${u.short}` : String(v.title).toLowerCase(); };
    const packAt = (v) => { const u = unitOf(v.option1), q = qtyOf(v.option1); return u.kind === 'laski' ? `${q} laskach` : packLabel(v); };
    const markUnitPrices = () => {
      const picker = getPicker();
      if (!picker) return;
      variants.forEach((v) => {
        const u = unitOf(v.option1);
        if (!u.kind || !unitPrice(v)) return;
        const radio = [...picker.querySelectorAll('input[type="radio"]')].find((r) => r.value === v.option1);
        const label = radio && picker.querySelector(`label[for="${CSS.escape(radio.id)}"]`);
        if (!label || label.querySelector('.vl-uprice')) return;
        label.classList.add('vl-has-uprice');
        label.insertAdjacentHTML('beforeend', `<span class="vl-uprice">${money(unitPrice(v))}/${unitShort[u.kind]}</span>`);
      });
    };

    let shownFor = null;
    // ramka nigdy się nie kurczy przy zmianie wariantu (żeby przycisk „Dodaj do koszyka” nie podskakiwał)
    let maxH = 0;
    const lockHeight = () => { const h = el.offsetHeight; if (h > maxH) { maxH = h; el.style.minHeight = h + 'px'; } };
    window.addEventListener('resize', () => { maxH = 0; el.style.minHeight = ''; lockHeight(); });
    const update = (id) => {
      const cur = variants.find((v) => v.id === Number(id || currentVariantId(productScope(el))));
      markUnitPrices();
      if (cur && shownFor === cur.id) return;
      best = variants.filter((v) => v.available).sort((a, b) => b.price - a.price)[0];
      if (!cur || !best || best.price < cur.price) { el.hidden = true; shownFor = null; return; }
      shownFor = cur.id;
      // największe opakowanie już wybrane: ramka zostaje (ta sama wysokość, nic nie podskakuje), tylko z potwierdzeniem
      if (best.id === cur.id || best.price === cur.price) {
        const u = unitOf(cur.option1);
        el.classList.add('is-best');
        msg.innerHTML = `<span class="vl-up__main">&#10003; Najlepszy wybór</span>` +
          `<span class="vl-up__sub">${u.kind && unitPrice(cur) ? `najniższa cena za ${u.per}: ${money(unitPrice(cur))}` : 'najniższa cena'}</span>`;
        badge.hidden = true;
        el.hidden = false;
        lockHeight();
        return;
      }
      el.classList.remove('is-best');
      const unit = unitOf(best.option1);
      const label = packLabel(best);
      // „2,95 zł za laskę w opakowaniu 20 lasek” i „zamiast 4,70 zł przy 10 laskach”
      if (unit.kind && unitPrice(best) && unitPrice(cur)) {
        msg.innerHTML = `<span class="vl-up__main"><strong>${money(unitPrice(best))} za ${unit.per}</strong> w opakowaniu <span class="vl-nowrap">${label}</span></span>` +
          `<span class="vl-up__sub">zamiast ${money(unitPrice(cur))} przy ${packAt(cur)}</span>`;
      } else {
        msg.innerHTML = `<span class="vl-up__main">Kup <strong>${label}</strong> za ${money(best.price)}</span>`;
      }
      badge.hidden = true;
      btn.innerHTML = `<span class="vl-up__btn-full">Wybierz ${label}</span><span class="vl-up__btn-short">Wybierz</span>`;
      el.hidden = false;
      lockHeight();
    };

    btn.addEventListener('click', () => {
      if (!best) return;
      const sel = getPicker() || productScope(el);
      const radio = [...sel.querySelectorAll('input[type="radio"]')].find((r) => r.value === best.option1);
      if (radio) {
        radio.click();
      } else {
        const select = [...sel.querySelectorAll('select')].find((s) => [...s.options].some((o) => o.value === best.option1));
        if (select) { select.value = best.option1; select.dispatchEvent(new Event('change', { bubbles: true })); }
      }
      track('upgrade_pdp');
      update(best.id);
    });

    document.addEventListener('theme:variant:prices-updated', (e) => { if (el.isConnected) update(e.detail && e.detail.variant && e.detail.variant.id); });
    document.addEventListener('change', (e) => {
      if (!el.isConnected || !e.target.closest('variant-selects, product-form, form[action*="/cart/add"]')) return;
      // od razu z klikniętej opcji (motyw aktualizuje wariant dopiero po ok. 0,5 s)
      const picked = e.target.matches('input[type="radio"]') && variants.find((v) => v.option1 === e.target.value);
      if (picked) update(picked.id); else setTimeout(() => update(), 120);
    });
    update();
  };

  /* ---------- Kup w zestawie ---------- */
  const initBundle = (el) => {
    if (el.dataset.vlReady) return;
    el.dataset.vlReady = '1';
    const limit = Number(el.dataset.limit || 0);
    const items = [...el.querySelectorAll('[data-vl-item]')];
    const totalEl = el.querySelector('[data-vl-total]');
    const noteEl = el.querySelector('[data-vl-note]');
    const addBtn = el.querySelector('[data-vl-bundle-add]');
    const msgEl = el.querySelector('[data-vl-bundle-msg]');

    const priceOf = (item) => {
      const v = item.querySelector('[data-vl-variant]');
      const opt = v.tagName === 'SELECT' ? v.selectedOptions[0] : v;
      return Number(opt.dataset.price || 0);
    };
    const recalc = () => {
      let sum = 0, n = 0;
      items.forEach((item) => {
        const p = priceOf(item);
        item.querySelector('[data-vl-price]').textContent = money(p);
        const on = item.querySelector('[data-vl-check]').checked;
        item.classList.toggle('is-off', !on);
        if (on) { sum += p; n++; }
      });
      totalEl.textContent = money(sum);
      noteEl.textContent = limit && sum >= limit ? 'Ten zestaw ma darmową dostawę.' : limit ? `Do darmowej dostawy brakuje ${money(limit - sum)}.` : '';
      addBtn.textContent = n > 1 ? `Dodaj ${n} produkty do koszyka` : 'Dodaj do koszyka';
    };
    const syncMain = (id) => {
      const main = el.querySelector('[data-vl-main] select[data-vl-variant]');
      const vid = String(id || currentVariantId(productScope(el)));
      if (main && [...main.options].some((o) => o.value === vid && !o.disabled)) { main.value = vid; recalc(); }
    };

    el.addEventListener('change', recalc);
    document.addEventListener('theme:variant:prices-updated', (e) => { if (el.isConnected) syncMain(e.detail && e.detail.variant && e.detail.variant.id); });
    addBtn.addEventListener('click', async () => {
      const payload = items
        .filter((item) => item.querySelector('[data-vl-check]').checked)
        .map((item) => ({ id: Number(item.querySelector('[data-vl-variant]').value), quantity: 1 }));
      addBtn.disabled = true;
      msgEl.hidden = true;
      try {
        await post('cart/add.js', { items: payload });
        // sam produkt główny (dodatki odznaczone) to zwykłe dodanie do koszyka, nie zestaw
        if (payload.length > 1) await track('zestaw');
        refreshCart(true);
      } catch (e) {
        msgEl.textContent = e.message;
        msgEl.hidden = false;
      } finally {
        addBtn.disabled = false;
      }
    });
    syncMain();
    recalc();
  };

  /* ---------- Koszyk: zamień na większe, dobierz ---------- */
  // Dodanie zawsze przez cart/add.js (na nim opierają się zdarzenia „dodano do koszyka” Klaviyo i pikseli),
  // od razu z nowym HTML koszyka (sections), więc bez osobnego odświeżania. Źródło zapisujemy w tle.
  const renderDrawer = (res) => {
    const html = res && res.sections && res.sections['api-cart-items'];
    const drawer = document.querySelector('cart-items[data-cart-drawer]');
    if (!html || !drawer || typeof drawer.build !== 'function') return false;
    const box = document.createElement('div');
    box.innerHTML = html;
    const content = box.querySelector('[data-api-content]');
    if (!content) return false;
    drawer.build(content);
    return true;
  };
  const cartTags = new Set(); // źródła zapisane w tej sesji (HTML koszyka może być starszy niż zapis w tle)
  document.addEventListener('click', async (e) => {
    const swap = e.target.closest('[data-vl-swap]');
    const add = e.target.closest('[data-vl-add]');
    const btn = swap || add;
    if (!btn) return;
    e.preventDefault();
    const row = btn.closest('.vl-c__row');
    if (row) row.classList.add('is-busy');
    btn.disabled = true;
    const box = btn.closest('[data-vl-cart]');
    const tag = swap ? 'upgrade_cart' : 'dobierz';
    String((box && box.dataset.vlAttr) || '').split(',').filter(Boolean).forEach((t) => cartTags.add(t));
    const needTag = !cartTags.has(tag);
    cartTags.add(tag);
    const tags = [...cartTags];
    let res = null;
    try {
      if (swap) await post('cart/change.js', { id: swap.dataset.key, quantity: 0 });
      const id = Number(swap ? swap.dataset.to : add.dataset.id);
      const quantity = swap ? Number(swap.dataset.qty || 1) : 1;
      try {
        res = await post('cart/add.js', { items: [{ id, quantity }], sections: 'api-cart-items', sections_url: location.pathname });
      } catch (err) {
        if (swap) await post('cart/add.js', { items: [{ id: Number(swap.dataset.from), quantity }] });
        throw err;
      }
      if (needTag) post('cart/update.js', { attributes: { _vl_upsell: tags.join(',') } }).catch(() => {});
    } catch (err) {
      console.warn('[vl-upsell]', err);
    }
    if (!renderDrawer(res)) refreshCart(false);
  });

  const init = () => {
    document.querySelectorAll('[data-vl-upgrade]').forEach(initUpgrade);
    document.querySelectorAll('[data-vl-bundle]').forEach(initBundle);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('theme:product-info:loaded', init);
  document.addEventListener('shopify:section:load', init);
})();
